import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FZS_78 } from "@/lib/programs/fezSidialiMarrakech78";

export default function FezSidialiMarrakech78Page() {
  return <ProgramTemplate program={PROGRAM_FZS_78} variant="fzs" showJourneyChronology />;
}
